import { AbstractRequirementMapper } from '@/features/CompanyQuestions/RequirementMapping/AbstractRequirementMapper';

export class VorversicherungGekuendigt extends AbstractRequirementMapper {
  protected frontendKey = 'vorversicherungsDaten.kuendigender';
}
